import React, { useEffect, useState } from 'react';
import { Circle, Polygon } from '@react-google-maps/api';
import { useFetchGeofences } from './Geofence.queries';
import { processorShapeOptions, producerShapeOptions } from './shapes/MapShapes.helpers';

const roleMap = {
    producer: producerShapeOptions,
    processor: processorShapeOptions,
};

const RadialGeofence = ({ shape }) => {
    const center = {
        lat: shape.center.coordinates[1],
        lng: shape.center.coordinates[0],
    };
    const options = roleMap[shape.user_id?.role] ?? producerShapeOptions;
    return <Circle key={shape._id} center={center} radius={shape.radius_meters} options={options} />;
};
const PolygonalGeofence = ({ shape }) => {
    const paths = shape.geometry.coordinates[0].map((point) => ({
        lat: point[1],
        lng: point[0],
    }));
    const options = roleMap[shape.user_id?.role] ?? producerShapeOptions;
    return <Polygon key={shape._id} paths={paths} options={{ ...options }} />;
};

const shapeMap = {
    radialGeofence: RadialGeofence,
    polygonalGeofence: PolygonalGeofence,
};

const useGeofences = ({ userIds, refetch, filterParams, enabled = true }) => {
    const [errorGeofences, setErrorGeofences] = useState(null);
    const [geofences, setGeofences] = useState([]);
    const [shapes, setShapes] = useState([]);

    const {
        data: fetchedGeofences,
        isLoading,
        error,
        refetch: refetchGeofences,
    } = useFetchGeofences({
        userIds,
        filterParams,
        enabled: enabled && !!userIds?.length,
    });

    useEffect(() => {
        setErrorGeofences(error);
    }, [error]);

    useEffect(() => {
        if (refetch) {
            refetchGeofences();
        }
    }, [refetch, refetchGeofences]);

    useEffect(() => {
        if (Array.isArray(fetchedGeofences)) {
            setGeofences(fetchedGeofences);
            const shapesArray = fetchedGeofences.map((fence) => {
                const Shape = shapeMap[fence.type];
                return <Shape key={fence._id} shape={fence} />;
            });
            setShapes(shapesArray);
        }
    }, [fetchedGeofences]);

    return { isLoading, geofences, setGeofences, shapes, errorGeofences };
};

export default useGeofences;
